'use strict';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.useSchemaStore = exports.RenderStoreProvider = exports.useRenderStore = exports.RenderStoreContext = exports.defaultRenderStore = void 0;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var _react = _interopRequireWildcard(require('react'));
var _reduxZero = _interopRequireDefault(require('redux-zero'));
var _lodash = _interopRequireDefault(require('lodash'));
var _react2 = require('redux-zero/react');
var _gemsRendererCore = require('@tencent/gems-renderer-core');
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2.default)(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
var defaultRenderStore = new _gemsRendererCore.RenderStore((0, _reduxZero.default)({}));
exports.defaultRenderStore = defaultRenderStore;
var RenderStoreContext = /*#__PURE__*/ _react.default.createContext(defaultRenderStore);
exports.RenderStoreContext = RenderStoreContext;
var useRenderStore = function() {
    return (0, _react.useContext)(RenderStoreContext);
};
exports.useRenderStore = useRenderStore;
var RenderStoreProvider = /*#__PURE__*/ function(_Component) {
    _inherits(RenderStoreProvider, _Component);
    var _super = _createSuper(RenderStoreProvider);
    function RenderStoreProvider(props) {
        _classCallCheck(this, RenderStoreProvider);
        var _this;
        var _props$renderStore;
        _this = _super.call(this, props);
        _this.state = {
            renderStore: (_props$renderStore = props.renderStore) !== null && _props$renderStore !== void 0 ? _props$renderStore : new _gemsRendererCore.RenderStore((0, _reduxZero.default)({}))
        };
        return _this;
    }
    _createClass(RenderStoreProvider, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var renderStore = this.state.renderStore;
                return(/*#__PURE__*/ _react.default.createElement(RenderStoreContext.Provider, {
                    value: renderStore
                }, /*#__PURE__*/ _react.default.createElement(_react2.Provider, {
                    store: renderStore.rootStore
                }, children)));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.renderStore && nextProps.renderStore !== prevState.renderStore) {
                    return {
                        renderStore: nextProps.renderStore
                    };
                }
                return null;
            }
        }
    ]);
    return RenderStoreProvider;
}(_react.default.Component);
/**
 * @description: 处理当前schema的store
 * @param {string[]} relativeStoreIds 相关联的storeId
 * @param {ComponentInstance | ActionInstance} instance
 * @param {IIterator} iterator
 * @return {any}
 */ exports.RenderStoreProvider = RenderStoreProvider;
var useSchemaStore = function(relativeStoreIds, instance, iterator) {
    var renderStore = useRenderStore();
    var schemaRelativeStateRef = (0, _react.useRef)({});
    var key = instance.key, _instance$component = instance.component, _instance$component2 = _instance$component === void 0 ? {} : _instance$component, _instance$component2$ = _instance$component2.store, store = _instance$component2$ === void 0 ? {} : _instance$component2$, action1 = instance.action; // 若为action的store
    if (action1) {
        store = action1 === null || action1 === void 0 ? void 0 : action1.store;
    }
    /**
   * 为循环组件创建storestate，放在对应key的state数组中
   * eg: 3:[{a: 1},{a: 2}]
   */ if ((0, _gemsRendererCore.isCircleComp)(iterator)) {
        renderStore.registerCircleSchemaStore(store, instance, iterator);
    } // 查找多层循环的索引list
    var getIndexList = renderStore.getIndexList;
    var indexList = getIndexList(iterator); // 关联依赖的store，检查前后是否有变化
    var schemaRelativeState = (0, _react2.useSelector)(function(state) {
        var _relativeStoreIds$red = relativeStoreIds.reduce(function(result, k) {
            return {
                hadChange: result.hadChange || schemaRelativeStateRef.current[k] !== state[k],
                relativeState: _objectSpread(_objectSpread({}, result.relativeState), {}, _defineProperty({}, k, state[k]))
            };
        }, {
            hadChange: false,
            relativeState: {}
        }), hadChange = _relativeStoreIds$red.hadChange, relativeState = _relativeStoreIds$red.relativeState;
        if (hadChange) {
            schemaRelativeStateRef.current = relativeState;
        }
        return schemaRelativeStateRef.current;
    });
    var schemaAction = (0, _react.useMemo)(function() {
        return renderStore.actions[key] ? Object.entries(renderStore.actions[key]).reduce(function(mapToActions, param) {
            var _param = _slicedToArray(param, 2), action = _param[0], actionHandler = _param[1];
            mapToActions[action] = renderStore.bindAction(key, actionHandler, iterator);
            return mapToActions;
        }, {}) : {};
    }, [
        key,
        renderStore.actions[key],
        JSON.stringify(iterator)
    ]); // 循环组件对应的action应该存在对应的iterator中
    if ((0, _gemsRendererCore.isCircleComp)(iterator)) {
        _lodash.default.set(renderStore.bindedActions, [
            key
        ].concat(_toConsumableArray(indexList)), schemaAction);
    } else {
        renderStore.bindedActions[key] = schemaAction;
    } // 拿取自身state
    var schemaState = (0, _gemsRendererCore.isCircleComp)(iterator) ? _lodash.default.get(schemaRelativeState, [
        key
    ].concat(_toConsumableArray(indexList))) : schemaRelativeState[key]; // schemaStore 平铺了组件的state和actions
    var schemaStore = _objectSpread(_objectSpread(_objectSpread({}, schemaState), schemaAction), {}, {
        key: key
    });
    return schemaStore;
};
exports.useSchemaStore = useSchemaStore;
